export interface CommercialOfferModel {
  id: string;
  uuid: string;
  createDate: string;
  lastModifiedDate: string;
  attachments?: Record<string, any>;
  offerNumber: string;
  status: string;
  reason?: string;
  negotiatePhase?: string;
  additionalInformation?: string;
  negotiateInformation?: string;
  itemsPrice: number;
  deliveryCost: number;
  additionalFees: number;
  total: number;
  validityDate: string;
  leadTime: {
    min: number;
    max: number;
    timeUnit: string;
  };
  substitute: boolean;
  alternative: boolean;
  formattedCreateDate?: string;
  formattedLastModifiedDate?: string;
  formattedValidityDate?: string;
  leadTimeText?: string;
  paymentTerms?: string | Record<string, any>;
}

export const CommercialOfferRejectionReasons = {
  BUDGET_CONSTRAINTS: { label: 'Budget constraints', value: 'BUDGET_CONSTRAINTS' },
  PRICE_TOO_HIGH: { label: 'Price too high', value: 'PRICE_TOO_HIGH' },
  TECHNICAL_REQUIREMENTS_NOT_MET: { label: 'Technical requirements not met', value: 'TECHNICAL_REQUIREMENTS_NOT_MET' },
  DELIVERY_TIMELINE_TOO_SLOW: { label: 'Delivery timeline too slow', value: 'DELIVERY_TIMELINE_TOO_SLOW' },
  FOUND_BETTER_ALTERNATIVE: { label: 'Found better alternative', value: 'FOUND_BETTER_ALTERNATIVE' },
  QUALITY_CONCERNS: { label: 'Quality concerns', value: 'QUALITY_CONCERNS' },
  OTHER: { label: 'Other', value: 'OTHER' },
};

export const CommercialOfferNegotiationReasons = {
  FIRST_CALL: { label: 'First call', value: 'FIRST_CALL' },
  ENGAGED: { label: 'Engaged', value: 'ENGAGED' },
  PRICE_DISCUSSION: { label: 'Price discussion', value: 'PRICE_DISCUSSION' },
  REQUEST_FOR_BETTER_PAYMENT_TERMS: {
    label: 'Request for better payment terms',
    value: 'REQUEST_FOR_BETTER_PAYMENT_TERMS',
  },
  ADJUST_DELIVERY_TIMELINE: { label: 'Adjust delivery timeline', value: 'ADJUST_DELIVERY_TIMELINE' },
  NEGOTIATING_WARRANTY_TERMS: { label: 'Negotiating warranty terms', value: 'NEGOTIATING_WARRANTY_TERMS' },
  OTHER: { label: 'Other', value: 'OTHER' },
};

export type OfferActionsTypes =
  | 'NEGOTIATE'
  | 'REQUEST_PRICE_CONFIRMATION'
  | 'SEND_PRE_INVOICE'
  | 'SEND_ORDER_CONFIRMATION'
  | 'SEND_COMMERCIAL_OFFER'
  | 'REJECT';
export const CommercialOfferActions: Record<OfferActionsTypes, { value: OfferActionsTypes; label: string }> = {
  NEGOTIATE: { value: 'NEGOTIATE', label: 'Negotiate' },
  REQUEST_PRICE_CONFIRMATION: { value: 'REQUEST_PRICE_CONFIRMATION', label: 'Request Price Confirmation' },
  SEND_PRE_INVOICE: { value: 'SEND_PRE_INVOICE', label: 'Send Pre-Invoice' },
  SEND_ORDER_CONFIRMATION: { value: 'SEND_ORDER_CONFIRMATION', label: 'Send Order Confirmation' },
  SEND_COMMERCIAL_OFFER: { value: 'SEND_COMMERCIAL_OFFER', label: 'Send Commercial Offer' },
  REJECT: { value: 'REJECT', label: 'Reject' },
};

export const GENERATE_COMMERCIAL_OFFER = 'GENERATE_COMMERCIAL_OFFER';
export type OfferActionType = keyof typeof CommercialOfferActions | typeof GENERATE_COMMERCIAL_OFFER;
